import uRLs from "./baseUtils";
import { getData, removeData, setData } from "./CookieUtiles";
import axios from "axios";

export const createToken = async (navigate, setLoggedIn) => {
  removeData("AccessToken");

  try {
    const refreshToken = getData("RefreshToken");

    if (!refreshToken) {
      setLoggedIn(false);  
      navigate("/login");
      return false;
    }

    const response = await axios.get(`${uRLs.BASE_URL}login/create-token`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (response.statuscode === 401 || response.statuscode === 500) {
      removeData("RefreshToken");
      setLoggedIn(false);
      navigate("/login");
      return false;
    }

    if (response.status === 201 && response.data.results?.accessToken) {
      window.location.reload();
      setData("AccessToken", response.data.results.accessToken);

      return response.data.results.accessToken;
    }
  } catch (error) {
    if (error) {
      const status = parseInt(error.response.data?.statuscode, 10);

      if (status === 401 || status === 500) {
        setLoggedIn(false);
        navigate("/login");
      }
    }

    return false;
  }
};


